import { render, staticRenderFns } from "./CZY006_Result.vue?vue&type=template&id=abd1bf7a&scoped=true&"
import script from "./CZY006_Result.vue?vue&type=script&lang=js&"
export * from "./CZY006_Result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd1bf7a",
  null
  
)

export default component.exports